import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import debug from 'debug';
import { ENV } from './types';
export var Environment = /*#__PURE__*/function () {
  _createClass(Environment, null, [{
    key: "modeFromHost",
    value: function modeFromHost(productionHosts, host) {
      return productionHosts.indexOf(host) !== -1 ? ENV.Production : ENV.Staging;
    }
  }]);

  function Environment(configuration, mode) {
    _classCallCheck(this, Environment);

    _defineProperty(this, "mode", void 0);

    _defineProperty(this, "configuration", void 0);

    this.configuration = configuration;
    this.mode = mode;
    this.get.bind(this);
  }

  _createClass(Environment, [{
    key: "get",
    value: function get(key) {
      var configurationValue = this.configuration[key]; // Note: If a configuration value is a string we assume it's the same for each environment

      var value = _typeof(configurationValue) === 'object' ? configurationValue[this.mode] : this.configuration[key];

      if (value === undefined) {
        console.error("Missing \"".concat(key, "\" key in environment \"").concat(this.mode, "\""));
      }

      return value;
    }
  }]);

  return Environment;
}();
export var createEnvironment = function createEnvironment(configuration) {
  var mode = process.env.BUILD_ENV;

  if (!mode) {
    console.error("Missing BUILD_ENV in env file");
  }

  var logger = debug('environment');
  logger("Running application with \"".concat(mode, "\" environment:"), configuration);
  return new Environment(configuration, mode);
};